//#region [IMPORT]

// === THIRD-PARTY ===
//import React, { createContext } from 'react';
import React, { createContext, useState, useEffect} from 'react';
// === STYLE / MATERIAL UI ===
import { useTheme   } from '@mui/material/styles' ;
import { Box        } from '@mui/material'        ;
import { grey       } from '@mui/material/colors' ;
import { prokeyApi} from 'api/prokey';
import ApiIcon from '@mui/icons-material/Api';
import {
  Button,  
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import { Typography } from '../../../../node_modules/@mui/material/index';

//#endregion

export function VersionButton() {

  //#region [VALUES]

  const theme  = useTheme();
  const _styles = {
    container: {
      display    : 'flex'  ,
      marginLeft : 'auto'  ,
      alignItems : 'center',
      padding    : '1rem'  ,
      '&:hover': {
        background: grey[300],
     },
    },
    text: {
      paddingLeft: '1rem',
    }
  };
  
  var pjson = require('../../../../package.json');
  const [open, setOpen] = useState(false);
  const [version , setVersion] = useState('')   
  
  //#endregion

  //#region [EVENTS]

  useEffect (() => {
  const response = async () => {
    try{
      const result = await prokeyApi.getVersion();
      setVersion(result.data);
 
    }catch (error) {
      console.error('error')}
  };
   response();
  }, []);
 
  const handleClick = () => {  
  if (open) {
    setOpen(false);

  } else {
    setOpen(true);   
  }
  };
  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (    
      <Box sx={_styles.container}  onClick={handleClick} name='open_version_dialog_btn'>
      <Dialog   
        open={open}       
      >
        <DialogTitle id='alert-dialog-title' color='primary'>
          {'Version Information'}
        </DialogTitle>
        <DialogContent>
         <DialogContentText>
           <Typography id='alert-dialog-description'>
            <li name='server_version_lbl'>PdWebServer version: <em>{ version }</em></li>
            <li name='client_version_lbl'>ProkeyClient version: <em>{ pjson.version }</em></li>
           </Typography>
         </DialogContentText>         
        </DialogContent>      
        <DialogActions>
          <Button name='close_version_dialog_btn'>
            Ok
          </Button>             
        </DialogActions>
      </Dialog>
        <ApiIcon color='primary'/>        
        <Box sx={_styles.text}> Version </Box>
      </Box>      
    );
  }      

  return display();
}
